import api from './api';

/**
 * Chiamate della fatturazione.
 *
 * Le regole stanno nel backend e nel database: qui non si duplicano
 * controlli, si presentano i messaggi che arrivano.
 */
export const fatturazioneAPI = {
    // --- soggetti
    soggettoDaPaziente: (pazienteId) =>
        api.post(`/fatturazione/soggetti/da-paziente/${pazienteId}`),
    cercaSoggetti: (q) => api.get('/fatturazione/soggetti', { params: { q } }),

    // --- prestazioni pronte da fatturare
    daFatturare: (pazienteId) => api.get(`/fatturazione/da-fatturare/${pazienteId}`),

    // --- documenti
    elenco: (params) => api.get('/fatturazione', { params }),
    /* params.paziente_id: dal contesto di un paziente il server serve solo
       un documento suo. La pagina Fatturazione lo chiama senza. */
    dettaglio: (id, params) => api.get(`/fatturazione/${id}`, { params }),
    creaBozza: (dati) => api.post('/fatturazione', dati),
    /* Il documento intero - bozza e righe - in una transazione: se una riga
       e' rifiutata non nasce niente, e il messaggio dice quale. */
    creaDocumento: (dati) => api.post('/fatturazione/documento', dati),
    aggiungiRiga: (id, riga) => api.post(`/fatturazione/${id}/righe`, riga),
    eliminaRiga: (id, rigaId) => api.delete(`/fatturazione/${id}/righe/${rigaId}`),
    impostaBollo: (id, escluso) => api.patch(`/fatturazione/${id}/bollo`, { escluso }),
    /* Sconto sul totale: il server lo ripartisce sulle basi imponibili
       aliquota per aliquota, cosi' l'IVA resta coerente con la base. */
    impostaSconto: (id, sconto) => api.patch(`/fatturazione/${id}/sconto`, { sconto }),
    // Quantita' e sconto di una riga in bozza, senza cancellarla e rifarla
    modificaRiga: (id, rigaId, dati) =>
        api.patch(`/fatturazione/${id}/righe/${rigaId}`, dati),
    emetti: (id, dati = {}) => api.post(`/fatturazione/${id}/emetti`, dati),
    annulla: (id, motivo) => api.post(`/fatturazione/${id}/annulla`, { motivo }),
    /* D5: la schermata che lascia una bozza la fa togliere se e' vuota; il
       server decide (bozza_vuota) e risponde { tolta }. */
    togliSeVuota: (id) => api.post(`/fatturazione/${id}/togli-se-vuota`),
    incassa: (id, dati) => api.post(`/fatturazione/${id}/incassi`, dati),
    spettanze: (params) => api.get('/fatturazione/spettanze', { params }),

    urlPdf: (id) => `/api/fatturazione/${id}/pdf`,
};

export const pacchettiAPI = {
    perPaziente: (pazienteId) => api.get(`/pacchetti/paziente/${pazienteId}`),
    /* «Continua pacchetto»: quelli che il medico collegato puo' continuare. */
    aperti: (pazienteId) => api.get(`/pacchetti/aperti/${pazienteId}`),
    annullaSeduta: (sedutaId, motivo) => api.post(`/pacchetti/sedute/${sedutaId}/annulla`, { motivo }),
    dettaglio: (id) => api.get(`/pacchetti/${id}`),
    inScadenza: (giorni = 30) => api.get('/pacchetti/in-scadenza', { params: { giorni } }),
    vendi: (dati) => api.post('/pacchetti', dati),
    consuma: (id, dati) => api.post(`/pacchetti/${id}/consuma`, dati),
    esenzione: (id, dati) => api.post(`/pacchetti/${id}/esenzione`, dati),
    fissaScadenza: (id, fatturaId) => api.post(`/pacchetti/${id}/scadenza`, { fattura_id: fatturaId }),
    recesso: (id) => api.get(`/pacchetti/${id}/recesso`),
    chiudi: (id, dati) => api.post(`/pacchetti/${id}/chiudi`, dati),
};

export default fatturazioneAPI;
